// extracted by mini-css-extract-plugin
module.exports = {"Question":"questions_Question__gf20y","Arrow":"questions_Arrow__3cmDC","ArrowOpen":"questions_ArrowOpen__1W6Hw","Answer":"questions_Answer__145QS","Open":"questions_Open__2Gzng"};